if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
                      if(document.querySelector(".cart_upsell_products")){
           document.querySelectorAll(".js-upsell-add-to-cart").forEach((button) => {
              button.addEventListener("click", function(event) {
          
                  let free_pro = event.target.getAttribute("data-variant-id");
                  let quantity = document.querySelector(".js-quantity-custom").querySelector("input").value;
                  const cartJson = '/cart.js';
                  window.getCartDrawerJson(free_pro, quantity,cartJson);
              })
          });
          document.querySelectorAll(".js-cart-upsell-add-to-cart").forEach((button) => {
              button.addEventListener("click", function(event) {
          
                  let free_pro = event.target.getAttribute("data-variant-id");
                  let quantity = document.querySelector(".js-quantity-custom").querySelector("input").value;
                  const cartJson = '/cart.js';
          
                  window.getCartJson(free_pro, quantity,cartJson);
              })
          });
        }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      // toggleSubmitButton(disable = true, text) {
      //   if (disable) {
      //     document.querySelector('.quantity_selector').classList.add('box-sold-out');
      //     this.submitButton.setAttribute('disabled', 'disabled');
      //     if (text) this.submitButtonText.textContent = text;
      //   } else {
      //     document.querySelector('.quantity_selector').classList.remove('box-sold-out');
      //     this.submitButton.removeAttribute('disabled');
      //     this.submitButtonText.textContent = window.variantStrings.addToCart;
      //   }
      // }
    toggleSubmitButton(disable = true, text) {
        const quantitySelector = document.querySelector('.quantity_selector');
        const plusSvg = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3984 11.4004V6.40039C13.3984 6.13517 13.2931 5.88082 13.1055 5.69328C12.918 5.50575 12.6637 5.40039 12.3984 5.40039C12.1332 5.40039 11.8789 5.50575 11.6913 5.69328C11.5038 5.88082 11.3984 6.13517 11.3984 6.40039V11.4004H6.39844C6.13322 11.4004 5.87887 11.5057 5.69133 11.6933C5.50379 11.8808 5.39844 12.1352 5.39844 12.4004C5.39844 12.6656 5.50379 12.92 5.69133 13.1075C5.87887 13.295 6.13322 13.4004 6.39844 13.4004H11.3984V18.4004C11.3984 18.6656 11.5038 18.92 11.6913 19.1075C11.8789 19.295 12.1332 19.4004 12.3984 19.4004C12.6637 19.4004 12.918 19.295 13.1055 19.1075C13.2931 18.92 13.3984 18.6656 13.3984 18.4004V13.4004H18.3984C18.6637 13.4004 18.918 13.295 19.1055 13.1075C19.2931 12.92 19.3984 12.6656 19.3984 12.4004C19.3984 12.1352 19.2931 11.8808 19.1055 11.6933C18.918 11.5057 18.6637 11.4004 18.3984 11.4004H13.3984Z" fill="#A6957D"></path></svg>`;
        
        // Remove existing SVG from the span
        // const existingSvg = this.submitButtonText.querySelector('svg');
        // if (existingSvg) {
        //   existingSvg.remove();
        // }
        
        if (disable) {
          quantitySelector.classList.add('box-sold-out');
          this.submitButton.setAttribute('disabled', 'disabled');
          
          if (text) {
            this.submitButtonText.textContent = text;
          }
        } else {
          quantitySelector.classList.remove('box-sold-out');
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.innerHTML = `${plusSvg} ${window.variantStrings.addToCart}`;
          
          // Add SVG inside the span (at the beginning)
          // this.submitButtonText.insertAdjacentHTML('afterbegin', plusSvg);
        }
      }

            get variantIdInput() {
              return this.form.querySelector('[name=id]');
            }
          }
        );
    }
